export default __webpack_public_path__ + "static/media/manual4.8c3c3696.png";